module.exports = __webpack_public_path__ + "img/marcyrl.d5176500.png";